










































































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import { ReviewEntity } from "@/entities";
import { State, Action } from "vuex-class";
import { AppConstants as _app } from "@/shared/app.constants";

@Component
export default class COIDeclarationComponent extends Vue {
  @State("reviewExternal") reviewEntity: ReviewEntity;
  @Action("setReviewId", { namespace: "reviewExternal" }) setReiewId: any;
  @Action("create", { namespace: "reviewForm" }) createReview: any;
  @Action("disagreeReviewCoi", { namespace: "reviewForm" })
  disagreeReviewCoi: any;

  declarationContent = _app.TagReviewDeclarationText;
  declineComment: string = "";
  dialog = false;
  enableBtn = true;
  applicationId;

  mounted() {
    // if (!this.reviewEntity || !this.reviewEntity.applicationId) {
    //   this.$router.push({
    //     name: "dashboard",
    //   });
    // }
  }

  /** Agree COI declaration and create new review */
  declarationSubmit() {
    let reviewerId = this.$route.params.reviewerId;
    let applicationId = this.$route.params.applicationId; // Application unique id
    let entity = this.$route.params.entity; // Entity type ConceptNote/Fullproposal 
    var self = this;
    self
      .createReview({entity: entity, reviewerId: reviewerId, applicationUniqueId: applicationId })
      .then((data: any) => {
        if (data && data.ExternalReviewId) {
          this.setReiewId(data.ExternalReviewId);
          this.$router.push({
            name: "reviewApplication",
            params: {
              reviewerId: reviewerId,
              applicationId: applicationId,
              entity: entity,
            },
          });
        }
      });
  }

  /** Declaration disagree */
  declarationDisagree() {
    var self = this;
    let applicationId = self.$route.params.applicationId; // Application unique id
    let entity = self.$route.params.entity;

    self
      .disagreeReviewCoi({
        applicationUniqueId: applicationId,
        entity: entity,
        Comments: self.declineComment,
      })
      .then((data: any) => {
        if (data) {
          self.declineComment = "";
          const key: any = "coiDisagree";
          this.$router.push({
            name: "genericNotification",
            query: { msgId: key },
          });
        }
      });
  }

  cancel() {
    this.dialog = false;
    this.declineComment = "";
  }

  save() {
    this.dialog = false;
    this.declarationDisagree();
  }

  @Watch("declineComment") commentWatch(newVal: string) {
    if (newVal.trim().length > 0) {
      this.enableBtn = false;
    } else {
      this.enableBtn = true;
    }
  }
}
